import { Injectable } from '@angular/core';
import { APISCockpit } from 'src/service/apis-cockpit';
import { TaskItem } from '../../taskcommon/taskcommon.class';
import { TaskOrderExtras } from './taskorderextras';

const API = '/api/construction-projects/v1/cockpit-taskorderextras/';

@Injectable({ providedIn: 'root' })
export class TaskOrderExtraService {

  taskOrderExtra: TaskOrderExtras = new TaskOrderExtras();
  taskOrdersExtras: TaskOrderExtras[] = [];

  constructor(private apiCockpit: APISCockpit) { }

  async GetTaskOrderExtra(itm: TaskItem) {
    if (typeof(itm?.companyid) !== 'undefined') {
      const url: string = API + itm.id;
      this.taskOrdersExtras = (await this.apiCockpit.getDataInfo(url)).items;
      if (this.taskOrdersExtras.length > 0) {
        this.taskOrderExtra = this.taskOrdersExtras[0];
      }
    }
    return this.taskOrderExtra;
  }

  async GetTaskOrderExtraByInput(itm: TaskItem) {
    if (typeof(itm?.companyid) !== 'undefined') {
      const url: string = API + itm.id + '/byinput/' + itm.inputId;
      this.taskOrdersExtras = (await this.apiCockpit.getDataInfo(url)).items;
      if (this.taskOrdersExtras.length > 0) {
        this.taskOrderExtra = this.taskOrdersExtras[0];
      }
    }
    return this.taskOrderExtra;
  }
}
